<template>
  <div v-if="showTab === OCR_LIST.code">
    <div class="section">
      <el-form
        label-position="left"
        label-width="90px"
      >
        <div class="el-form-item-wrapper" style="display: flex">
          <el-form-item :label="$t('CargoMsg.Cargo_IdentifyTemplateName')">
            <el-input v-model="params.templateName" style="width: 150px;padding-left: 10px" clearable />
          </el-form-item>
          <div style="padding-left: 10px">
            <el-button type="primary" @click="initOcrTemplate">
              {{ $t('CargoMsg.Cargo_Query') }}
            </el-button>
            <el-button type="primary" @click="addHandler">
              {{ $t('CargoMsg.Cargo_Add') }}
            </el-button>
            <el-button type="primary" @click="onCopy">
              {{ $t('CargoMsg.Cargo_Copy') }}
            </el-button>
            <el-button type="danger" @click="onDelete">
              {{ $t('CargoMsg.Cargo_Delete') }}
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="261602"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </div>
  </div>
  <!--详情页/提示词页-->
  <ocr-template-config-detail
    v-else-if="showTab === OCR_DETAIL.code"
    :ocr-template="currentOcrTemplate"
    :initial-action="action"
    @goBack="() => {
      if(lastShowTab) {
        showTab = lastShowTab
        lastShowTab = null
      } else {
        initOcrTemplate();
        showTab = OCR_LIST.code
      }
    }"
    @ocrTemplateSave="(val) => currentOcrTemplate = val"
  />
  <!--代码处理-->
  <ocr-code-handle
    v-else-if="showTab === OCR_CODE_HANDLE.code"
    :ocr-template="currentOcrTemplate"
    @goBack="() => {
      if(lastShowTab) {
        showTab = lastShowTab
        lastShowTab = null
      } else {
        initOcrTemplate();
        showTab = OCR_LIST.code
      }
    }"
  />
  <!--测试文件-->
  <ocr-test-file
    v-else-if="showTab === OCR_TEST_FILE.code"
    :ocr-template="currentOcrTemplate"
    @goBack="() => {
      initOcrTemplate();
      showTab = OCR_LIST.code
    }"
    @jump="(tab) => {
      showTab = tab
      lastShowTab = OCR_TEST_FILE.code
    }"
  />
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import OperationRender from '@/components/OperationRender'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { activeOcrTemplate, copyOcrTemplate, deleteTemplateFunc, getOcrTemplateList } from '@/api/ocrTemplate'
import OcrTemplateConfigDetail from '@/views/cargo/v0/SystemMaintenance/components/ocr/ocrTemplateConfigDetail'
import OcrCodeHandle from '@/views/cargo/v0/SystemMaintenance/components/ocr/ocrCodeHandle'
import OcrTestFile from '@/views/cargo/v0/SystemMaintenance/components/ocr/ocrTestFile'
import {
  OCR_CODE_HANDLE,
  OCR_DETAIL,
  OCR_LIST,
  OCR_TEMPLATE_STATUS_INVALID,
  OCR_TEMPLATE_STATUS_VALID, OCR_TEST_FILE
} from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OcrTemplateConfig',
  components: { OcrTemplateConfigDetail, OcrCodeHandle, OcrTestFile },
  data() {
    return {
      OCR_LIST, OCR_DETAIL, OCR_CODE_HANDLE, OCR_TEST_FILE,
      showTab: OCR_LIST.code, // list-列表，detail-详情，codeHandle-代码处理，testFile-测试文件
      action: 'edit', // edit 编辑；look 查看
      lastShowTab: null, // 记录上一个页面
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: event => { this.currentOcrTemplate = event.data }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_TemplateId'),
          field: 'uuid'
        }, {
          headerName: this.$t('CargoMsg.Cargo_IdentifyTemplateName'),
          field: 'templateName'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'active',
          cellRenderer: (params) => {
            return ColumnUtils.ocrTemplateStatusLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateTime'), field: 'dateModified', colId: 'dateModified', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          colId: '',
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_View'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.lookHandler(params)
                },
                visible: () => true
              },
              {
                title: this.$t('CargoMsg.Cargo_Edit'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.editHandler(params)
                },
                visible: () => true
              }, {
                title: this.$t('CargoMsg.Cargo_Disable'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: #f57174',
                onClick: (params) => {
                  this.disableHandler(params)
                },
                visible: (params) => params.active === OCR_TEMPLATE_STATUS_VALID.code
              }, {
                title: this.$t('CargoMsg.Cargo_Enable'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.enableHandler(params)
                },
                visible: (params) => params.active === OCR_TEMPLATE_STATUS_INVALID.code
              }, {
                title: this.$t('CargoMsg.Cargo_CodeProcessing'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.codeHandler(params)
                },
                visible: () => true
              }, {
                title: this.$t('CargoMsg.Cargo_TestFile'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.testFileHandler(params)
                },
                visible: () => true
              }
            ]
          }
        }
      ],
      rowData: [],
      params: { templateName: null },
      currentOcrTemplate: null,
      loading: null,
      gridApi: null
    }
  },
  created() {
    this.initOcrTemplate()
  },
  methods: {
    initOcrTemplate() {
      this.loading = getLoading4Cxt()
      getOcrTemplateList(this.params).then(res => {
        this.rowData = res.data || []
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.currentOcrTemplate = {
        active: OCR_TEMPLATE_STATUS_VALID.code
      }
      this.action = 'edit'
      this.showTab = OCR_DETAIL.code
    },
    onCopy() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length > 1) {
        this.$message.info(this.$t('CargoMsg.Cargo_SelectOneData'))
        return
      }
      this.loading = getLoading4Cxt()
      copyOcrTemplate({ ocrTemplateUuid: rows[0].uuid }).then(res => {
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.rowData = [...this.rowData, res.data]
        // 跳转编辑页
        this.editHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    lookHandler(params) {
      this.currentOcrTemplate = params
      this.action = 'look'
      this.showTab = OCR_DETAIL.code
    },
    editHandler(params) {
      // 模板生效且被租户绑定时，不可【编辑】、不可【代码处理】
      if (OCR_TEMPLATE_STATUS_VALID.code === params.active && params.used) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TemplateUsed'))
        return
      }
      this.currentOcrTemplate = params
      this.action = 'edit'
      this.showTab = OCR_DETAIL.code
    },
    disableHandler(params) {
      this.$confirm(this.$t('CargoMsg.Cargo_InValidThisRecognitionTemplate'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        params.active = OCR_TEMPLATE_STATUS_INVALID.code
        this.loading = getLoading4Cxt()
        activeOcrTemplate(params).then(res => {
          this.$message.success(this.$t('common.tips.saveSuccess'))
          this.gridApi.refreshCells({ force: true })
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    enableHandler(params) {
      this.$confirm(this.$t('CargoMsg.Cargo_ValidThisRecognitionTemplate'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        params.active = OCR_TEMPLATE_STATUS_VALID.code
        this.loading = getLoading4Cxt()
        activeOcrTemplate(params).then(res => {
          this.$message.success(this.$t('common.tips.saveSuccess'))
          this.gridApi.refreshCells({ force: true })
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    codeHandler(params) {
      // 模板生效且被租户绑定时，不可【编辑】、不可【代码处理】
      if (OCR_TEMPLATE_STATUS_VALID.code === params.active && params.used) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TemplateUsed'))
        return
      }
      this.currentOcrTemplate = params
      this.showTab = OCR_CODE_HANDLE.code
    },
    onDelete() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectDeleteTip'))
        return
      }
      const list = []
      for (const data of rows) {
        // 模板生效且被租户绑定时，不可【编辑】、不可【代码处理】
        if (OCR_TEMPLATE_STATUS_VALID.code === data.active && data.used) {
          list.push(data)
        }
      }
      if (list.length > 0) {
        const names = list.map(data => data.templateName).join('、')
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectDeleteTip2', [names]))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SelectDeleteTip3'), this.$t('Message.WarmReminder'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt()
        const uuids = []
        for (const data of rows) {
          uuids.push(data.uuid)
        }
        deleteTemplateFunc(uuids).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.initOcrTemplate()
          this.gridApi.refreshCells({ force: true })
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    testFileHandler(params) {
      this.currentOcrTemplate = params
      this.showTab = OCR_TEST_FILE.code
    }
  }
}
</script>
